import React from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, TextField, Rating } from "@mui/material";
import api from "../../api/api";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

dayjs.locale("pt-br");

const Create = (props) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      name: "",
      starRating: 1,
      videoUrl: "",
      order: 1,
    },
  });

  const onSubmit = async (data) => {
    try {
      const res = await api.post("/testimonials", {
        ...data,
        starRating: Number(data.starRating) || 1,
        order: Number(data.order) || 1,
      });
      if (res.status === 201) {
        reset();
        props.setStep("");
      }
    } catch (error) {
      console.error("Erro ao criar depoimento:", error);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="mb-8">
        <div className="flex items-center justify-between mb-6">
          <Button
            variant="outlined"
            onClick={() => props.setStep("")}
            className="p-2"
          >
            <ArrowBackIcon className="w-5 h-5" />
          </Button>
          <div className="flex-1 text-center">
            <h1 className="text-3xl font-bold text-gray-800">
              Criar Novo Depoimento
            </h1>
          </div>
          <div className="w-10"></div>{" "}
          {/* Espaçador para centralizar o título */}
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold text-blue-800 mb-3">
            Informações Importantes
          </h2>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-blue-700">
                <strong>Avaliação:</strong> Deve ser entre 1 e 5 estrelas
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-blue-700">
                <strong>Vídeo:</strong> ID que tem na URL do vídeo no Vimeo (ex:
                975187389)
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-blue-700">
                <strong>Nome:</strong> Nome que será exibido no depoimento
              </p>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nome do Depoimento"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Ex: João da Silva"
                />
              )}
            />

            <div>
              <p className="text-gray-600">Avaliação (1 a 5 estrelas)</p>
              <Controller
                name="starRating"
                control={control}
                render={({ field }) => (
                  <Rating
                    name="starRating"
                    value={Number(field.value) || 1}
                    onChange={(event, newValue) => {
                      field.onChange(newValue ? Number(newValue) : 1);
                    }}
                  />
                )}
              />
            </div>
          </div>

          <div className="mt-6">
            <Controller
              name="videoUrl"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="ID do Vídeo Vimeo"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Ex: 975187389"
                />
              )}
            />
          </div>

          <div className="mt-6">
            <Controller
              name="order"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Ordem"
                  type="number"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Ex: 1"
                />
              )}
            />
          </div>
        </div>

        <div className="flex gap-4 pt-6">
          <Button
            type="button"
            color="error"
            variant="outlined"
            onClick={() => props.setStep("")}
            className="px-6 py-3"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="px-6 py-3"
          >
            Criar Depoimento
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Create;
